import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import GeneralOptions from '@/pages/Users/PublicProfile/GeneralOptions'

import Loading from '@/shared/Loading'

const PostUserRow = ({ postUser }) => {
  return <li className='flex items-start gap-3 px-3 py-2 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700/50'>
    <img className='h-9 w-9 shrink-0 rounded-full bg-gray-200 object-cover' src={postUser.publicImageUrl} alt='' />
    <div className='min-w-0 flex-1'>
      <div className='flex items-center justify-between gap-2 text-sm'>
        <Link to={`/m/${postUser.userUsername}`} className='font-medium truncate text-gray-900 dark:text-white'>{postUser.userDisplayName}</Link>
        <GeneralOptions user={postUser.user} blocking={false} />
      </div>
      <div className='text-xs text-gray-500 dark:text-gray-400 line-clamp-2' dangerouslySetInnerHTML={{ __html: postUser.headline }} />
    </div>
  </li>
}

// The right-hand panel, and the drawer below xl. The thread's people are
// fetched once by PrivatePostsIndex and shared with the conversation header.
// Leave lives in that header.
const PrivatePostPeopleInThisThread = ({ people, loading }) => {
  return <div className='flex-1 min-h-0 flex flex-col'>
    <h3 className='shrink-0 px-4 pt-4 pb-2 text-xs font-bold uppercase tracking-wider text-gray-500 dark:text-gray-400'>
      In this thread{people.length > 0 && ` (${people.length})`}
    </h3>
    <ul className='flex-1 min-h-0 overflow-y-auto px-1'>
      {people.map(pu => <PostUserRow key={`privpostus${pu.id}`} postUser={pu} />)}
      {loading && <li><Loading /></li>}
    </ul>
  </div>
}

export default PrivatePostPeopleInThisThread

PostUserRow.propTypes = {
  postUser: PropTypes.object.isRequired
}
PrivatePostPeopleInThisThread.propTypes = {
  people: PropTypes.array.isRequired,
  loading: PropTypes.bool
}
